import { CUSTOM_FONT_FACES_ID } from 'const';
import { UIFontFace } from 'models';
import { compareFacesByWeightWithLastUnicode } from '../utils/styles/compareFacesByWeightWithLastUnicode';

function getFontFaces(UIFontFaces: UIFontFace[]): string[] {
  // should be the same as BE (artboardsJsonToPDF) to make sorting determenistic
  return [...UIFontFaces]
    .filter(Boolean)
    .sort(compareFacesByWeightWithLastUnicode)
    .map(({ fontFamily, fontStyle, fontWeight, src }) => {
      const fontFamilyString = `font-family: "${fontFamily}";`;
      const fontStyleString = fontStyle ? `font-style: ${fontStyle};` : '';
      const fontWeightString = fontWeight ? `font-weight: ${fontWeight};` : '';
      const fontDisplayString = 'font-display: swap;';
      const srcString = `src: url("${src}");`;

      return `@font-face { ${fontFamilyString} ${fontStyleString} ${fontWeightString} ${fontDisplayString} ${srcString} }`;
    });
}

export function appendCustomFontFaces(UIFontFaces: UIFontFace[], document = window.document): void {
  const fontFaceStyleToRemove = document.getElementById(CUSTOM_FONT_FACES_ID);
  if (fontFaceStyleToRemove) {
    document.head.removeChild(fontFaceStyleToRemove);
  }

  const fontFaces = getFontFaces(UIFontFaces);
  const fontFaceStyleElement = document.createElement('style');
  fontFaceStyleElement.id = CUSTOM_FONT_FACES_ID;
  fontFaceStyleElement.appendChild(document.createTextNode([...fontFaces].join('\n')));
  document.head.appendChild(fontFaceStyleElement);
}
